export default {
  
  en: {
    dataDt: 'Date',
    appName: 'APP',
    appSsid: 'Plate Number',
    installs: 'Installation',
    optCount: 'OTP Sent Count',
    regCount: 'Register',
    basicCount: 'Basic Info',
    workCount: 'Work Info',
    linkmanCount: 'Contact',
    jsonCount: 'JSON',
    idimageCount: 'ID Photo',
    faceCount: 'Face Photo',
    idnoCount: 'ID Info',
    bankcardCount: 'Bank Card',
    applyCount: 'Apply',
    accessCount: 'Pass',
    loanCount: 'Loan',
    installsOptRate: 'SMS Rate',
    optRegRate: 'Reg Rate',
    regBasicRate: 'Basic Info Rate',
    regApplyRate: 'Reg Apply Rate',
    installApplyRate: 'Install Apply Rate',
    applyAccessRate: 'Pass Rate',
    workLinkmanRate: 'Contact Rate',
    linkedManJsonRate: 'JSON Rate',
    jsonIdimageRate: 'ID Photo Rate',
    idimageFaceRate: 'Face Photo Rate',
    faceidNoRate: 'ID Info Rate',
    idNoBankcardRate: 'Bank Card Rate',
    bankcardApplyRate: 'Apply Rate',
    accessLoanRate: 'Loan Rate',
    regBankCardRate: 'Reg-Card Rate',
    applyLoanRate: 'Apply-Loan Rate',
    regLoanRate: 'Reg-Loan Rate',
    baseBeforeRate: 'Basic Info Rate/Before',
    workBeforeRate: 'Work Info Rate/Before',
    linkBeforeRate: 'Contact Rate/Before',
    jsonBeforeRate: 'JSON Rate/Before',
    idCardBeforeRate: 'ID Photo Rate/Before',
    faceBeforeRate: 'Face Photo Rate/Before',
    bankCardBeforeRate: 'Bank Card Rate/Before',
    applyBeforeRate: 'Apply Rate/Before',
    loanBeforeRate: 'Loan Rate',
    cardRegisterRate: 'Reg-Card Rate/Before',
    appVersion: 'Category',
    productType: 'Product Type',
    dataScope: 'Data Scope',
    regToday: 'Registration Day',
    regNear3Days: 'Within 3 Days of Registration',
    regNear7Days: 'Within 7 Days of Registration',
    query: 'Query',
  },
  es: {
    dataDt: 'Ngày',
    appName: 'APP',
    appSsid: 'Số đĩa',
    installs: 'Cài đặt',
    optCount: 'Số điện thoại OTP đăng ký gửi',
    regCount: 'Đăng ký',
    basicCount: 'Thông tin cơ bản',
    workCount: 'Thông tin công việc',
    linkmanCount: 'Người tham chiếu',
    jsonCount: 'JSON lớn',
    idimageCount: 'Ảnh mặt trước của CMND/CCCD ',
    faceCount: 'Ảnh khuôn mặt',
    idnoCount: 'Thông tin CMND/CCCD',
    bankcardCount: 'Thông tin nhận tiền',
    applyCount: 'Nộp hồ sơ',
    accessCount: 'Hồ sơ qua bước xét duyệt',
    loanCount: 'Giải ngân',
    installsOptRate: 'Tỷ lệ gửi SMS',
    optRegRate: 'Tỷ lệ đăng ký',
    regBasicRate: 'Tỷ lệ hoàn thành thông tin cơ bản',
    regApplyRate: 'Tỷ lệ chuyển đổi Đăng ký → Nộp hồ sơ',
    installApplyRate: 'Tỷ lệ cài đặt vay',
    applyAccessRate: 'Tỷ lệ phê duyệt',
    workLinkmanRate: 'Tỷ lệ hoàn thành người tham chiếu',
    linkedManJsonRate: 'Tỷ lệ hoàn thành JSON',
    jsonIdimageRate: 'Tỷ lệ hoàn thành ảnh CMND/CCCD',
    idimageFaceRate: 'TTỷ lệ hoàn thành ảnh khuôn mặt',
    faceidNoRate: 'Tỷ lệ hoàn thành thông tin CCCD',
    idNoBankcardRate: 'Tỷ lệ hoàn thành thông tin nhận tiền',
    bankcardApplyRate: 'Tỷ lệ nộp hồ sơ',
    accessLoanRate: 'Tỷ lệ giải ngân',
    regBankCardRate: 'Tỷ lệ chuyển đổi Đăng ký → Liên kết thẻ',
    applyLoanRate: 'Tỷ lệ chuyển đổi Nộp hồ sơ → Giải ngân',
    regLoanRate: 'Tỷ lệ chuyển đổi Đăng ký → Giải ngân',
    baseBeforeRate: 'Tỷ lệ thông tin cơ bản/trước',
    workBeforeRate: 'Tỷ lệ thông tin công việc/trước',
    linkBeforeRate: 'Tỷ lệ người liên hệ/trước',
    jsonBeforeRate: 'Tỷ lệ JSON/trước',
    idCardBeforeRate: 'Tỷ lệ ảnh CMND/trước',
    faceBeforeRate: 'Tỷ lệ ảnh khuôn mặt/trước',
    bankCardBeforeRate: 'Tỷ lệ thông tin nhận tiền/trước',
    applyBeforeRate: 'Tỷ lệ đăng ký vay/trước',
    loanBeforeRate: 'Tỷ lệ giải ngân',
    cardRegisterRate: 'Tỷ lệ đăng ký-thẻ/trước',
    appVersion: 'Phân loại',
    productType: 'Loại sản phẩm',
    dataScope: 'Phạm vi dữ liệu',
    regToday: 'Ngày đăng ký',
    regNear3Days: 'Trong 3 ngày đăng ký',
    regNear7Days: 'Trong 7 ngày đăng ký',
    query: 'Truy vấn',
  }
}
